var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative","padding-top":"12px","padding-bottom":"24px"},attrs:{"id":"app"}},[_c('Loader',{ref:"loader"}),_c('router-view',{staticStyle:{"max-width":"1000px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }